import React from 'react';

export default function Wine() {
	// 17
	let style = {
		st0: {
 			fill:"#FFFFFF"
		},
		st138: {
 			fill:"#BC669B"
		},
		st139: {
 			fill:"#DB79BA"
		}
	};
	return (
		<g>
			<path style={style.st138} d="M102.8184052,338.5260315c0,16.8907776,13.6924438,30.4938049,30.5832214,30.4938049
				s30.5832062-13.5583496,30.5832062-30.4490967L102.8184052,338.5260315z"/>
			<ellipse style={style.st139} cx="133.4016266" cy="338.1160583" rx="29.3139057" ry="5.2039328"/>
			<path style={style.st0} d="M165.984375,338.347168c0-14.3007812-8.4716797-29.8227539-8.8330078-30.4765625
				c-0.0117188-0.0211182-0.027832-0.0377197-0.0402832-0.0582275c-0.0073242-0.0123901-0.0095215-0.0266724-0.017334-0.0389404
				c-0.0288086-0.0456543-0.0715332-0.0888672-0.1022949-0.1341553c-0.0324707-0.0429688-0.0622559-0.0878906-0.0974121-0.1276245
				c-2.5722656-3.5097656-11.7392578-5.8704224-23.1782227-5.9428101c-0.0283203-0.0014648-0.0556641-0.0019531-0.0839844-0.0019531
				h-0.4609375c-0.0283203,0-0.0556641,0.0004883-0.0839844,0.0019531
				c-11.4370117,0.0723877-20.6035156,2.4325562-23.1767578,5.9418945c-0.0356445,0.0404053-0.0661621,0.0861816-0.0991211,0.1300049
				c-0.0302734,0.0447998-0.0727539,0.0875244-0.1010742,0.1326904c-0.0078125,0.0122681-0.0100098,0.0264282-0.017334,0.0388184
				c-0.0124512,0.0205688-0.0285645,0.0371704-0.0402832,0.0583496c-0.3613281,0.6538086-8.8339844,16.1757812-8.8339844,30.4765625
				c0,16.954895,13.0180664,30.9198608,29.5830078,32.4398804v15.1208496
				c-5.7675781,0.265686-17.3408203,1.4494019-17.3408203,6.6775513c0,6.5644531,18.2587891,6.7539062,20.3408203,6.7539062
				s20.3417969-0.1894531,20.3417969-6.7539062c0-5.2282104-11.5742188-6.4118652-17.3417969-6.6775513v-15.1208496
				C152.9663086,369.2670288,165.984375,355.302063,165.984375,338.347168z M133.4013672,305.5673828
				c9.8681641,0.0268555,16.2607422,1.7915039,18.9550781,3.2695312c-2.6943359,1.4785156-9.0869141,3.2431641-18.9550781,3.2700195
				c-9.8681641-0.0268555-16.2597656-1.7915039-18.9541016-3.2700195
				C117.1416016,307.3588867,123.5332031,305.5942383,133.4013672,305.5673828z M104.8183594,338.347168
				c0-10.2595215,4.9401855-21.6384277,7.2143555-26.3327026c3.9846191,2.4642944,11.7700195,4.0322266,21.0541992,4.0910034
				c0.0283203,0.0014648,0.0556641,0.0019531,0.0839844,0.0019531h0.4609375c0.0283203,0,0.0556641-0.0004883,0.0839844-0.0019531
				c9.2858887-0.0587769,17.0717773-1.6269531,21.0561523-4.0916748c2.2739258,4.6893921,7.2124023,16.0564575,7.2124023,26.333374
				c0,15.7612305-12.8222656,28.5834961-28.5830078,28.5834961S104.8183594,354.1083984,104.8183594,338.347168z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Wine.js